import { render, staticRenderFns } from "./Error4XX.vue?vue&type=template&id=f3cc51a4&scoped=true"
import script from "./Error4XX.vue?vue&type=script&lang=js"
export * from "./Error4XX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cc51a4",
  null
  
)

export default component.exports